/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Appraisal_reatedStage01 } from '../models/Appraisal_reatedStage01';
import type { AppraisalResponsePagedListData } from '../models/AppraisalResponsePagedListData';
import type { AppraisalStage01 } from '../models/AppraisalStage01';
import type { AppraisalStage03 } from '../models/AppraisalStage03';
import type { AppraisalStage04 } from '../models/AppraisalStage04';
import type { AppraisalStage05 } from '../models/AppraisalStage05';
import type { AppraisalStage06 } from '../models/AppraisalStage06';
import type { AppraisalStage07 } from '../models/AppraisalStage07';
import type { AppraisalStage09 } from '../models/AppraisalStage09';
import type { AppraisalStage101 } from '../models/AppraisalStage101';
import type { AppraisalStage12 } from '../models/AppraisalStage12';
import type { AppraisalStageStatus } from '../models/AppraisalStageStatus';
import type { AppraisalType } from '../models/AppraisalType';
import type { ApraisalHeader } from '../models/ApraisalHeader';
import type { AprsalCatDamagePartDto } from '../models/AprsalCatDamagePartDto';
import type { AprsalCatDamageRepairDto } from '../models/AprsalCatDamageRepairDto';
import type { AprsalCatDamageTypeDto } from '../models/AprsalCatDamageTypeDto';
import type { AprsalStage02Dto } from '../models/AprsalStage02Dto';
import type { CopyAppraisalRequest } from '../models/CopyAppraisalRequest';
import type { DamageAndRepairPrice } from '../models/DamageAndRepairPrice';
import type { FullCheckCapHpiViewModel } from '../models/FullCheckCapHpiViewModel';
import type { GetAppraisalPhotosModel } from '../models/GetAppraisalPhotosModel';
import type { HistoryAppraisal } from '../models/HistoryAppraisal';
import type { SimpleEmailSendModel } from '../models/SimpleEmailSendModel';
import type { SimpleEmailSendModelAppraisal } from '../models/SimpleEmailSendModelAppraisal';
import type { SimpleSmsModel } from '../models/SimpleSmsModel';
import type { SimpleSmsModelAppraisal } from '../models/SimpleSmsModelAppraisal';
import type { Stage01Dto } from '../models/Stage01Dto';
import type { Stage03Dto } from '../models/Stage03Dto';
import type { Stage04Dto } from '../models/Stage04Dto';
import type { Stage05Dto } from '../models/Stage05Dto';
import type { Stage06Dto } from '../models/Stage06Dto';
import type { Stage07Dto } from '../models/Stage07Dto';
import type { Stage08Dto } from '../models/Stage08Dto';
import type { Stage09Dto } from '../models/Stage09Dto';
import type { Stage10Dto } from '../models/Stage10Dto';
import type { Stage10Lookups } from '../models/Stage10Lookups';
import type { Stage10SaveModel } from '../models/Stage10SaveModel';
import type { Stage12Dto } from '../models/Stage12Dto';
import type { StageHistoryDto } from '../models/StageHistoryDto';
import type { SubjofViewAndLostOpportunity } from '../models/SubjofViewAndLostOpportunity';
import type { TypeReport } from '../models/TypeReport';
import type { UploadsAppraisalPhotos } from '../models/UploadsAppraisalPhotos';
import type { VdiFullCheckViewModel } from '../models/VdiFullCheckViewModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AppraisalService {

  /**
   * @param id
   * @returns GetAppraisalPhotosModel Success
   * @throws ApiError
   */
  public static getApiAppraisalAppraisalPhotos(
    id?: number,
  ): CancelablePromise<GetAppraisalPhotosModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Appraisal/AppraisalPhotos',
      query: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns any Created
   * @throws ApiError
   */
  public static postApiAppraisalAppraisalPhotos(
    requestBody?: UploadsAppraisalPhotos,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Appraisal/AppraisalPhotos',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id
   * @param mileage
   * @param userId
   * @returns void
   * @throws ApiError
   */
  public static getApiAppraisalLookupsForStage101(
    id?: number,
    mileage?: number,
    userId?: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Appraisal/LookupsForStage101',
      query: {
        'id': id,
        'mileage': mileage,
        'userId': userId,
      },
    });
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static postApiAppraisalCopyAppraisal(
    requestBody?: CopyAppraisalRequest,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Appraisal/CopyAppraisal',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param appraisalId
   * @returns void
   * @throws ApiError
   */
  public static getApiAppraisalGenerateCustomerReportPdf(
    appraisalId?: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/generate-customer-report-pdf',
      query: {
        'appraisalId': appraisalId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get models for appraisals search
   * @returns string Success
   * @throws ApiError
   */
  public static getAppraisalsModels(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/appraisals/models',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get appraisals list
   * @param type
   *
   * 1 = Appraisal
   *
   * 2 = CheckIn
   * @param from
   * @param to
   * @param branchId
   * @param userId
   * @param regNumber
   * @param hasStockNumber
   * @param hasDeal
   * @param hasDesirable
   * @param hasNextContact
   * @param vehicleSearchManufacture
   * @param vehicleSearchCarModel
   * @param vehicleSearchPriceMin
   * @param vehicleSearchPriceMax
   * @param vehicleSearchYearMin
   * @param vehicleSearchYearMax
   * @param vehicleSearchMileageMin
   * @param vehicleSearchMileageMax
   * @param paginatePage
   * @param paginatePageSize
   * @returns AppraisalResponsePagedListData Success
   * @throws ApiError
   */
  public static getAppraisals(
    type?: AppraisalType,
    from?: string,
    to?: string,
    branchId?: number,
    userId?: number,
    regNumber?: string,
    hasStockNumber?: boolean,
    hasDeal?: boolean,
    hasDesirable?: boolean,
    hasNextContact?: boolean,
    vehicleSearchManufacture?: string,
    vehicleSearchCarModel?: string,
    vehicleSearchPriceMin?: number,
    vehicleSearchPriceMax?: number,
    vehicleSearchYearMin?: number,
    vehicleSearchYearMax?: number,
    vehicleSearchMileageMin?: number,
    vehicleSearchMileageMax?: number,
    paginatePage?: number,
    paginatePageSize?: number,
  ): CancelablePromise<AppraisalResponsePagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/appraisals',
      query: {
        'Type': type,
        'From': from,
        'To': to,
        'BranchId': branchId,
        'UserId': userId,
        'RegNumber': regNumber,
        'HasStockNumber': hasStockNumber,
        'HasDeal': hasDeal,
        'HasDesirable': hasDesirable,
        'HasNextContact': hasNextContact,
        'VehicleSearch.Manufacture': vehicleSearchManufacture,
        'VehicleSearch.CarModel': vehicleSearchCarModel,
        'VehicleSearch.PriceMin': vehicleSearchPriceMin,
        'VehicleSearch.PriceMax': vehicleSearchPriceMax,
        'VehicleSearch.YearMin': vehicleSearchYearMin,
        'VehicleSearch.YearMax': vehicleSearchYearMax,
        'VehicleSearch.MileageMin': vehicleSearchMileageMin,
        'VehicleSearch.MileageMax': vehicleSearchMileageMax,
        'Paginate.Page': paginatePage,
        'Paginate.PageSize': paginatePageSize,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param formData
   * @returns string Success
   * @throws ApiError
   */
  public static postApiAppraisalUploadImage(
    formData?: {
      img?: Blob;
    },
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/upload-image',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Delete appraisal
   * @param id ID of the appraisal.
   * @returns void
   * @throws ApiError
   */
  public static deleteApiAppraisal(
    id: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/appraisal/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Create appraisal
   * @param requestBody Model for step create apprailsal and step
   * @returns any Created
   * @throws ApiError
   */
  public static postApiAppraisalCreateNewAppraisal(
    requestBody?: Appraisal_reatedStage01,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/create-new-appraisal',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save car appraisal stage 1-01 details
   * @param id Appraisal Id
   * @param requestBody An instance of the AdvanceVauxhall.Common.Models.Appraisal.AppraisalStage01 class containing stage 1-01 details.
   * @returns any Created
   * @throws ApiError
   */
  public static postApiAppraisalsStages1(
    id: number,
    requestBody?: AppraisalStage01,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisals/{id}/stages/1',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save car appraisal stage 2-01 details
   * @param id
   * @param formData
   * @returns any Created
   * @throws ApiError
   */
  public static postApiAppraisalStages2(
    id: number,
    formData?: {
      /**
       * Mileage of the vehicle.
       */
      Mileage: number;
      /**
       * Flag indicating whether the odometer has been changed.
       */
      OdometerChanged?: boolean;
      /**
       * Flag indicating whether there is mileage discrepancy.
       */
      MileageDisc?: boolean;
      /**
       * Flag indicating whether there are dashboard warnings.
       */
      DashboardWarn?: boolean;
      /**
       * Photo of the dashboard.
       */
      DashboardPhoto?: string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/2',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get the details for stage 02 of an appraisal.
   * @param id The ID of the appraisal.
   * @returns AprsalStage02Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalStages2(
    id: number,
  ): CancelablePromise<AprsalStage02Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/stages/2',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Saves appraisal details for stage 3
   * @param id Appraisal id
   * @param requestBody The model for saving stage 3.
   * @returns any Success
   * @throws ApiError
   */
  public static postApiAppraisalStages3(
    id: number,
    requestBody?: AppraisalStage03,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/3',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get the details for stage 03 of an appraisal.
   * @param id The ID of the appraisal.
   * @returns Stage03Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalStages3(
    id: number,
  ): CancelablePromise<Stage03Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/stages/3',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save appraisal stage 4-01 details
   * @param id
   * @param requestBody Model for saving stage 04
   * @returns void
   * @throws ApiError
   */
  public static postApiAppraisalStages4(
    id: number,
    requestBody?: AppraisalStage04,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/4',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save appraisal stage 5-01 details
   * @param id
   * @param requestBody An instance of the AdvanceVauxhall.Common.Models.Appraisal.AppraisalStage05 class containing appraisal details.
   * @returns void
   * @throws ApiError
   */
  public static postApiAppraisalStages5(
    id: number,
    requestBody?: AppraisalStage05,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/5',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save appraisal stage 6 01 details
   * @param id
   * @param requestBody An instance of the AdvanceVauxhall.Common.Models.Appraisal.AppraisalStage06 class containing appraisal details.
   * @returns any Created
   * @throws ApiError
   */
  public static postApiAppraisalStages6(
    id: number,
    requestBody?: AppraisalStage06,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/6',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save appraisal stage 7-01 details
   * @param id
   * @param requestBody An instance of the AdvanceVauxhall.Common.Models.Appraisal.AppraisalStage07 class containing appraisal details.
   * @returns void
   * @throws ApiError
   */
  public static postApiAppraisalStages7(
    id: number,
    requestBody?: AppraisalStage07,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/7',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save appraisal stage 8-01 details
   * @param id
   * @param formData
   * @returns void
   * @throws ApiError
   */
  public static postApiAppraisalStages8(
    id: number,
    formData?: {
      /**
       * ID of the division.
       */
      DivId: number;
      /**
       * ID of the part.
       */
      PartId: number;
      /**
       * ID of the type.
       */
      TypeId: number;
      /**
       * ID of the repair.
       */
      RepairId: number;
      /**
       * X coordinates.
       */
      CoordsX: number;
      /**
       * Y coordinates.
       */
      CoordsY: number;
      /**
       * Additional notes.
       */
      Notes: string;
      /**
       * Price.
       */
      Price?: number;
      /**
       * File path or URL for the photo.
       */
      Photo?: Blob;
    },
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/8',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save appraisal stage 9-01 detail
   * @param id
   * @param requestBody An instance of the AdvanceVauxhall.Common.Models.Appraisal.AppraisalStage09 class containing appraisal details.
   * @returns any Created
   * @throws ApiError
   */
  public static postApiAppraisalStages9(
    id: number,
    requestBody?: AppraisalStage09,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/9',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save appraisal stage 10-01 details
   * @param id
   * @param requestBody An instance of the AdvanceVauxhall.Common.Models.Appraisal.AppraisalStage10 class containing appraisal details.
   * @returns any Created
   * @throws ApiError
   */
  public static postApiAppraisalStages10(
    id: number,
    requestBody?: Stage10SaveModel,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/10',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get category damage division part details.
   * @returns AprsalCatDamagePartDto Success
   * @throws ApiError
   */
  public static getApiAppraisalGetCatDivPart(): CancelablePromise<Array<AprsalCatDamagePartDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/get-cat-div-part',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get category damage division type details.
   * @param groupId
   * @returns AprsalCatDamageTypeDto Success
   * @throws ApiError
   */
  public static getApiAppraisalGetCatDivType(
    groupId?: number,
  ): CancelablePromise<Array<AprsalCatDamageTypeDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/get-cat-div-type',
      query: {
        'groupId': groupId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get category damage division repair details.
   * @param groupId
   * @returns AprsalCatDamageRepairDto Success
   * @throws ApiError
   */
  public static getApiAppraisalGetCatDivRepair(
    groupId?: number,
  ): CancelablePromise<Array<AprsalCatDamageRepairDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/get-cat-div-repair',
      query: {
        'groupId': groupId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Save appraisal stage 101-01 details.
   * @param id
   * @param requestBody An instance of the AdvanceVauxhall.Common.Models.Appraisal.AppraisalStage101 class containing appraisal details.
   * @returns any Created
   * @throws ApiError
   */
  public static postApiAppraisalStages101(
    id: number,
    requestBody?: AppraisalStage101,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/101',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Saves the appraisal stage 12 details.
   * @param id
   * @param requestBody The details of appraisal stage 12.
   * @returns any Created
   * @throws ApiError
   */
  public static postApiAppraisalStages12(
    id: number,
    requestBody?: AppraisalStage12,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/stages/12',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @param formData
   * @returns string Success
   * @throws ApiError
   */
  public static postApiAppraisalsStagesUploadPdf(
    id: string,
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisals/{id}/stages/upload-pdf',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param regNo
   * @returns HistoryAppraisal Success
   * @throws ApiError
   */
  public static getApiAppraisalGetAppraisalsFromLastSixMounth(
    regNo?: string,
  ): CancelablePromise<Array<HistoryAppraisal>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/get-appraisals-from-last-six-mounth',
      query: {
        'regNo': regNo,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param appraisalId
   * @returns SubjofViewAndLostOpportunity Success
   * @throws ApiError
   */
  public static getApiAppraisalGetLostOpportunityAndSubjOfViewByAppraisalId(
    appraisalId?: number,
  ): CancelablePromise<SubjofViewAndLostOpportunity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/get-lost-opportunity-and-subjOfView-by-AppraisalId',
      query: {
        'appraisalId': appraisalId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns ApraisalHeader Success
   * @throws ApiError
   */
  public static getApiAppraisalGetHeaderApraisalById(
    id: number,
  ): CancelablePromise<ApraisalHeader> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/get-header-apraisal-by-id',
      path: {
        'id': id,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * Uploads a settlement PDF file for a specific appraisal.
   * @param id ID of the appraisal.
   * @param userId ID of the user performing the upload.
   * @param formData
   * @returns string Success
   * @throws ApiError
   */
  public static postApiAppraisalsStagesUploadSettlementPdf(
    id: number,
    userId?: number,
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisals/{id}/stages/upload-settlement-pdf',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param regNo
   * @returns FullCheckCapHpiViewModel Success
   * @throws ApiError
   */
  public static getApiAppraisalGetFullCapHpiHistory(
    regNo?: string,
  ): CancelablePromise<FullCheckCapHpiViewModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/get-full-cap-hpi-history',
      query: {
        'regNo': regNo,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns StageHistoryDto Success
   * @throws ApiError
   */
  public static getApiAppraisalGetAllHistory(
    id: number,
  ): CancelablePromise<Array<StageHistoryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/get-all-history',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static putApiAppraisalUpdateVehicleDamagePrice(
    id: number,
    requestBody?: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/appraisal/update-vehicle-damage-price/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static putApiAppraisalUpdateVehicleDamageNotes(
    id: number,
    requestBody?: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/appraisal/update-vehicle-damage-notes/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static postApiAppraisalSendSms(
    id: number,
    requestBody?: SimpleSmsModel,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/send-sms',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static postApiAppraisalSendEmail(
    id: number,
    requestBody?: SimpleEmailSendModel,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/{id}/send-email',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns SimpleEmailSendModelAppraisal Success
   * @throws ApiError
   */
  public static getApiAppraisalGetAppraisalEmail(
    id: number,
  ): CancelablePromise<SimpleEmailSendModelAppraisal> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/get-appraisal-email',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns SimpleSmsModelAppraisal Success
   * @throws ApiError
   */
  public static getApiAppraisalGetAppraisalSms(
    id: number,
  ): CancelablePromise<SimpleSmsModelAppraisal> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/get-appraisal-sms',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public static getApiAppraisalGeneratePurchasePdf(
    id: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/generate-purchase-pdf',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param regno
   * @returns VdiFullCheckViewModel Success
   * @throws ApiError
   */
  public static getApiAppraisalGetVdiFullCheck(
    regno?: string,
  ): CancelablePromise<VdiFullCheckViewModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/get-vdi-full-check',
      query: {
        'regno': regno,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param regno
   * @returns VdiFullCheckViewModel Success
   * @throws ApiError
   */
  public static getApiAppraisalRequestVdiFullCheck(
    regno?: string,
  ): CancelablePromise<VdiFullCheckViewModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/request-vdi-full-check',
      query: {
        'regno': regno,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static getApiAppraisalStage10Lookup(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/stage10-lookup',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static getApiAppraisalSignableSendDocument(
    id?: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/signable-send-document',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public static deleteApiAppraisalDeleteSettlementPdf(
    id: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/appraisal/{id}/delete-settlement-pdf',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get Stage 01 details for a specific appraisal ID.
   * @param id ID of the appraisal.
   * @returns Stage01Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalStages1(
    id: number,
  ): CancelablePromise<Stage01Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/stages/1',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get the details for stage 04 of an appraisal.
   * @param id The ID of the appraisal.
   * @returns Stage04Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalsStages4(
    id: number,
  ): CancelablePromise<Stage04Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisals/{id}/stages/4',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get the details for stage 05 of an appraisal.
   * @param id The ID of the appraisal.
   * @returns Stage05Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalsStages5(
    id: number,
  ): CancelablePromise<Stage05Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisals/{id}/stages/5',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get the details for stage 06 of an appraisal.
   * @param id The ID of the appraisal.
   * @returns Stage06Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalsStages6(
    id: number,
  ): CancelablePromise<Stage06Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisals/{id}/stages/6',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get the details for stage 07 of an appraisal.
   * @param id The ID of the appraisal.
   * @returns Stage07Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalsStages7(
    id: number,
  ): CancelablePromise<Stage07Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisals/{id}/stages/7',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get the details for stage 08 of an appraisal.
   * @param id The ID of the appraisal.
   * @returns Stage08Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalsStages8(
    id: number,
  ): CancelablePromise<Array<Stage08Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisals/{id}/stages/8',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get details for stage 09 of an appraisal.
   * @param id The ID of the appraisal.
   * @returns Stage09Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalsStages9(
    id: number,
  ): CancelablePromise<Stage09Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisals/{id}/stages/9',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get details for stage 10 of an appraisal.
   * @param id The ID of the appraisal.
   * @returns Stage10Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalsStages10(
    id: number,
  ): CancelablePromise<Stage10Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisals/{id}/stages/10',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns Stage10Lookups Success
   * @throws ApiError
   */
  public static getApiAppraisalStage10Lookup1(
    id: number,
  ): CancelablePromise<Stage10Lookups> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/stage10-lookup',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Get Stage 12 details for a specific appraisal ID.
   * @param id ID of the appraisal.
   * @returns Stage12Dto Success
   * @throws ApiError
   */
  public static getApiAppraisalsStages12(
    id: number,
  ): CancelablePromise<Stage12Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisals/{id}/stages/12',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @param subjOfView
   * @returns void
   * @throws ApiError
   */
  public static putApiAppraisalСhangeSubjOfView(
    id: number,
    subjOfView?: boolean,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/appraisal/{id}/сhange-subj-of-view',
      path: {
        'id': id,
      },
      query: {
        'subjOfView': subjOfView,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @param lostOpportunity
   * @returns void
   * @throws ApiError
   */
  public static putApiAppraisalСhangeLostOpportunity(
    id: number,
    lostOpportunity?: boolean,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/appraisal/{id}/сhange-lost-opportunity',
      path: {
        'id': id,
      },
      query: {
        'lostOpportunity': lostOpportunity,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @returns AppraisalStageStatus Success
   * @throws ApiError
   */
  public static getApiAppraisalGetStatusOfAppraisalStages(
    id: number,
  ): CancelablePromise<AppraisalStageStatus> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/{id}/get-status-of-appraisal-stages',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param divPartId
   * @param damagePartId
   * @param damageTypeId
   * @param damageRepairId
   * @returns number Success
   * @throws ApiError
   */
  public static getApiAppraisalGetDamageRepairPrice(
    divPartId?: number,
    damagePartId?: number,
    damageTypeId?: number,
    damageRepairId?: number,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/appraisal/get-damage-repair-price',
      query: {
        'DivPartId': divPartId,
        'DamagePartId': damagePartId,
        'DamageTypeId': damageTypeId,
        'DamageRepairId': damageRepairId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static postApiAppraisalsStagesCompleteAppraisal(
    id: number,
    formData?: {
      customerReportFile?: Blob;
      auctionReportFile?: Blob;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisals/{id}/stages/complete-appraisal',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postApiAppraisalInsertDamageRepairPrice(
    requestBody?: DamageAndRepairPrice,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisal/insert-damage-repair-price',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id
   * @param type
   *
   * 1 = Customer
   *
   * 2 = Auction
   * @returns void
   * @throws ApiError
   */
  public static postApiAppraisalsReportsSend(
    id: number,
    type: TypeReport,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/appraisals/{id}/reports/{type}/send',
      path: {
        'id': id,
        'type': type,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

}
